<template>
    <img alt="" :class="`r:100% block w:${size} h:${size} bg:#efefef ${clickable ? 'cursor:pointer' : ''}`" @click="click" :src="url" v-if="url" />
    <div :class="`inline-flex w:${size} h:${size}`" v-else>
        <button :class="`inline-flex w:${size} h:${size} ai:center jc:center bg:primary f:${size/2} color:white round ${clickable ? '' : 'cursor:default!'}`" @click="click" type="button">
            {{ shortName }}
        </button>
    </div>
</template>

<script setup>
    const props = defineProps({
        clickable: { default: false, type: Boolean },
        iconUrl: { type: String },
        shortName: { type: String },
        size: { default: 32, type: Number },
        type: { default: 3, type: Number }
    });

    const prefix = inject("prefix");
    const url = ref();

    const changeType = () => {
        switch (props.type) {
            case 1:
            case 2:
            case 5:
                url.value = `${prefix}asset/image/avatar-college.svg`;
                break;
            case 3:
                url.value = props.iconUrl;
                break;
            case 4:
                url.value = `${prefix}asset/image/avatar-nickname.svg`;
                break;
            case 6:
                url.value = `${prefix}asset/image/avatar-group-master.svg`;
                break;
        }
    };

    const click = () => {
        if (props.clickable) {
            emit('click');
        }
    };

    const emit = defineEmits(['click']);

    changeType();

    watch(props, changeType, { deep: true });
</script>
